module.exports = __webpack_public_path__ + "d3cd20f2f1aa384521963fdc4c93293d.glb";